import type { JSX } from 'preact';
import type { UiMessage } from '../hooks/useChat';
import { parseMessage } from '../lib/format';

export function MessageBubble({ message }: { message: UiMessage }): JSX.Element {
  const errorClass = message.status === 'error' ? ' error' : '';

  // The customer's own text is shown verbatim; assistant text is parsed so stray
  // Markdown is stripped and any inline link renders as a chip, not a bare URL.
  const content =
    message.role === 'assistant'
      ? parseMessage(message.text).map((segment) =>
          segment.type === 'link' ? (
            <a class="sa-msg-link" href={segment.href} target="_blank" rel="noopener noreferrer">
              {segment.text}
            </a>
          ) : (
            segment.value
          ),
        )
      : message.text;

  return (
    <div class={`sa-row ${message.role}`}>
      <div class={`sa-bubble${errorClass}`} dir="auto">
        {content}
      </div>
    </div>
  );
}
